import {
  CATEGORY_DISCOUNT_LIST_REQUEST,
  CATEGORY_DISCOUNT_LIST_SUCCESS,
  CATEGORY_DISCOUNT_LIST_FAIL,
} from "../constants/categoryDiscountConstants";

export const categoryDiscountListReducer = (state = { discounts: [] }, action) => {
  switch (action.type) {
    case CATEGORY_DISCOUNT_LIST_REQUEST:
      return { loading: true, discounts: [] };
    case CATEGORY_DISCOUNT_LIST_SUCCESS:
      return { loading: false, discounts: action.payload };
    case CATEGORY_DISCOUNT_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
